import { BLOCKQUOTE_TYPES } from "@repo/fika-blog/src/nodes/blockquoteNode"
import type { Editor } from "@repo/fika-blog/src/tiptap/core"
import type { NodeSelection } from "@repo/fika-blog/src/tiptap/pm/state"
import type { AccentHue } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { createEditorTransaction } from "solid-tiptap"
import { Mini } from "@/designSystem/components/mini/mini"
import { Tooltip } from "@/designSystem/components/tooltip"
import { DeleteButton, ParentButton } from "@/designSystem/patterns/editor-menu"

type Props = {
  editor: Editor
}

export function BlockquoteMenu(props: Props) {
  const selection = createEditorTransaction(
    () => props.editor,
    editor => editor.state.selection as NodeSelection,
  )

  const blockquoteOptions = () => {
    return [
      {
        iconName: "x" as IconName,
        label: "none",
        value: null,
        hue: "sand" as AccentHue,
      },
      ...Object.entries(BLOCKQUOTE_TYPES).map(([value, option]) => ({
        value,
        label: option.title,
        iconName: option.icon,
        hue: option.hue,
      })),
    ]
  }

  return (
    <Mini.Menu>
      <Mini.Section>
        <ParentButton editor={props.editor} />
      </Mini.Section>
      <Mini.Section>
        <Tooltip
          label="blockquote type"
          hue={
            BLOCKQUOTE_TYPES[selection().node.attrs.calloutType ?? "none"]?.hue
          }
        >
          <Mini.Select
            items={blockquoteOptions()}
            value={selection().node.attrs.calloutType ?? "none"}
            fixedIcon="messages-square"
            defaultLabel="type"
            onChange={calloutType => {
              props.editor
                .chain()
                .command(({ tr }) => {
                  const { from } = selection()
                  const attrs = {
                    ...selection().node.attrs,
                    calloutType: calloutType === "none" ? null : calloutType,
                  }
                  tr.setNodeMarkup(from, undefined, attrs)
                  return true
                })
                .run()
            }}
          />
        </Tooltip>
        <Tooltip label="title">
          <Mini.TextField
            placeholder="title"
            value={selection().node.attrs.title}
            onChange={title => {
              props.editor
                .chain()
                .command(({ tr }) => {
                  const { from } = selection()
                  const attrs = { ...selection().node.attrs, title }
                  tr.setNodeMarkup(from, undefined, attrs)
                  return true
                })
                .run()
            }}
          />
        </Tooltip>
      </Mini.Section>
      <Mini.Section>
        <DeleteButton editor={props.editor} />
      </Mini.Section>
    </Mini.Menu>
  )
}
